<div class="crp-roles__label" *ngIf="addCrpMode; else editARole">
  {{ 'crp.form.title.add' | translate }}
</div>
<ng-template #editARole>
  <div class="crp-roles__label">
   {{ 'crp.form.title.edit' | translate }}
  </div>
</ng-template>
<form class="add-role-form" [formGroup]="form">
  <div class="add-role-form__role-container">
    <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_nested-select add-role-form__role" [matMenuTriggerFor]="rolesMenu">
      <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
      <input matInput formControlName="role" placeholder="{{ 'crp.form.label.appointment' | translate }}">
    </mat-form-field>
    <mat-menu #rolesMenu="matMenu" class="custom-mat-menu-panel custom-mat-menu-panel_nested-select">
      <ng-container *ngFor="let roleGroup of rolesList">
        <button mat-menu-item [matMenuTriggerFor]="menu">{{roleGroup.category}}</button>
        <mat-menu #menu="matMenu" class="custom-mat-menu-panel custom-mat-menu-panel_nested-select">
          <button mat-menu-item *ngFor="let role of roleGroup.roles" (click)="setSelectedRole(role)">{{role}}</button>
        </mat-menu>
      </ng-container>
    </mat-menu>
    <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory add-role-form__role" appearance="fill" *ngIf="form.get('role').value?.toLowerCase() === 'please specify'">
      <mat-label> {{ 'crp.form.label.other_role' | translate }} </mat-label>
      <textarea matInput rows="6" formControlName="otherRole"></textarea>
    </mat-form-field>
  </div>
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker add-role-form__field">
    <input matInput [matDatepicker]="pickerAppointed" placeholder="{{ 'crp.form.label.date_appointed' | translate }}"
      formControlName="dateAppointed" (focus)="pickerAppointed.open()" [max]="maxDateAppointed">
    <mat-datepicker-toggle matSuffix [for]="pickerAppointed"></mat-datepicker-toggle>
    <mat-datepicker #pickerAppointed></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker add-role-form__field">
    <input matInput [matDatepicker]="pickerResigned" placeholder="{{ 'crp.form.label.date_resigned' | translate }}"
      formControlName="dateResigned" (focus)="pickerResigned.open()" [min]="minDateResigned">
    <mat-datepicker-toggle matSuffix [for]="pickerResigned"></mat-datepicker-toggle>
    <mat-datepicker #pickerResigned></mat-datepicker>
  </mat-form-field>
  <div class="add-role-form__btn-container" *ngIf="addCrpMode; else cancelRole">
    <button mat-button ubi-round-button class="btn btn_small btn_accent-gradient-rounded add-role-form__btn add-role-form__btn_save" (click)="submit()" [disabled]="form.valid && form.dirty ? null: ''">{{currentRole?.id? 'UPDATE':'SAVE'}}</button>
  </div>
  <ng-template #cancelRole>
    <div class="add-role-form__btn-container">
      <button mat-button ubi-round-button class="btn btn_small btn_rounded add-role-form__btn add-role-form__btn_cancel" (click)="cancelAddRole()"> {{ 'crp.button.cancel' | translate }} </button>
      <button mat-button ubi-round-button class="btn btn_small btn_accent-gradient-rounded add-role-form__btn add-role-form__btn_save" (click)="submit()" [disabled]="!(form.valid && form.dirty)">{{currentRole?.id? 'UPDATE':'SAVE'}}</button>
    </div>
  </ng-template>
</form>
<div class="role-list__table-and-paginator">
  <div class="role-list__table-container">
    <table mat-table class="custom-mat-table role-table" matSort [dataSource]="dataSource">
      <ng-container matColumnDef="role">
        <th mat-header-cell mat-sort-header *matHeaderCellDef class="role-table__header_role"> {{ 'general.table.label.role' | translate }}  </th>
        <td mat-cell *matCellDef="let item" class="role-table__cell">{{item.role}}</td>
      </ng-container>
      <ng-container matColumnDef="dateAppointed">
        <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.date_appointed' | translate }} </th>
        <td mat-cell *matCellDef="let item" class="role-table__cell">
          {{item.dateAppointed ? (item.dateAppointed  | date:'dd/MM/yyyy') : '-'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="dateResigned">
        <th mat-header-cell *matHeaderCellDef> {{ 'general.table.label.date_resigned' | translate }} </th>
        <td mat-cell *matCellDef="let item" class="role-table__cell">
          {{item.dateResigned ? (item.dateResigned  | date:'dd/MM/yyyy') : '-'}}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef class="role-table__header_actions"> {{ 'general.table.label.actions' | translate }} </th>
        <td mat-cell *matCellDef="let item; let i = index">
          <img (click)="editRole(item,i)" class="themified-white-icon role-table__action-icon" src="/assets/icons/edit-icon.png">
          <img (click)="deleteRole(item,i)" class="themified-white-icon role-table__action-icon" src="/assets/icons/minus-icon-white.png">
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
  <div class="table-empty" *ngIf="paginator.length === 0">
    {{ 'crp.message.no_crp' | translate }}
  </div>
  <mat-paginator class="custom-mat-paginator" [length]="paginator.length" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
</div>
